module.exports = __webpack_public_path__ + "img/DAB-Profile-Andreas-Gregori.40953e28.png";